import { jsxs as j, jsx as i } from "react/jsx-runtime";
import { useRef as k, useState as A, useMemo as E, useCallback as p, createElement as w } from "react";
import P from "classnames";
import { noop as U } from "lodash/fp";
import f from "./index.es2389.js";
import { MenuListContainer as D } from "./index.es82.js";
import { BASIC_MENU_ITEM_HEIGHT as H, BasicMenuItem as N } from "./index.es77.js";
import { onKeyDownEnter as x } from "./index.es500.js";
import { UtilityChevronIcon as G } from "./index.es422.js";
const V = ({
  items: s,
  setItems: v,
  testId: R = "cascading-menu",
  maxVisibleItems: m,
  onItemSelection: h = U,
  subMenuOpeningLogicBy: b = "hover",
  menuWidth: g
}) => {
  var y;
  const C = k(null), M = k(null), u = b === "click", [r, l] = A(""), B = P(f.menuList, {
    [f.subMenuOpen]: r !== ""
  }), d = E(
    () => {
      var t, e;
      return ((t = s.find(({ value: n }) => n === r)) == null ? void 0 : t.subItems) || ((e = s.find(({ subItems: n }) => n == null ? void 0 : n.some(({ isSelected: o }) => o))) == null ? void 0 : e.subItems) || [];
    },
    [r, s]
  ), a = p(
    (t) => {
      v(
        s.map((e) => {
          if (e.value === t.value)
            return { ...e, isSelected: !0 };
          if (e.subItems) {
            const n = e.subItems.map(
              (o) => o.value === t.value ? { ...o, isSelected: !0 } : { ...o, isSelected: !1 }
            );
            return { ...e, subItems: n, isSelected: !1 };
          }
          return { ...e, isSelected: !1 };
        })
      );
    },
    [s, v]
  ), I = p(
    (t, e) => {
      var n, o;
      if (!((n = t.subItems) != null && n.length)) {
        a(t), h(t);
        return;
      }
      (o = e == null ? void 0 : e.stopPropagation) == null || o.call(e), u && (t.value === r ? l("") : (a(t), l(t.value)));
    },
    [r, a, h, u]
  ), K = (t, e) => {
    var n;
    (n = e == null ? void 0 : e.stopPropagation) == null || n.call(e), t.value === r ? l("") : (a(t), l(t.value)), setTimeout(() => {
      var o;
      (o = M.current) == null || o.focus();
    }, 100);
  }, L = p((t) => {
    l(t.value);
  }, []), O = E(() => ({
    "--cascading-menu-width": g + "px"
  }), [g]);
  return /* @__PURE__ */ j(
    "div",
    {
      ref: C,
      "data-testid": R,
      className: f.root,
      style: O,
      onMouseLeave: () => !u && l(""),
      children: [
        /* @__PURE__ */ i("div", { className: B, children: /* @__PURE__ */ i(
          D,
          {
            itemHeight: H,
            itemCount: s.length,
            maxVisibleItems: m,
            children: ({ index: t, style: e }) => {
              const n = s[t], { subItems: o, ...S } = n, T = n.isSelected || (o == null ? void 0 : o.some(({ isSelected: c }) => c));
              return /* @__PURE__ */ w(
                N,
                {
                  ...S,
                  key: n.value,
                  wrapperStyle: e,
                  onClick: (c) => I(n, c),
                  onMouseEnter: () => !u && L(n),
                  onKeyDown: (c) => x(
                    c,
                    (_) => K(n, _),
                    !1
                  ),
                  isSelected: T,
                  hasDivider: t < s.length - 1,
                  RightComponent: o ? /* @__PURE__ */ i(G, { direction: "left" }) : S.RightComponent
                }
              );
            }
          }
        ) }),
        d.length > 0 && /* @__PURE__ */ i("div", { className: f.subMenu, style: { height: (y = C.current) == null ? void 0 : y.clientHeight }, children: /* @__PURE__ */ i(
          D,
          {
            itemHeight: H,
            itemCount: d.length,
            maxVisibleItems: m,
            ref: M,
            children: ({ index: t, style: e }) => {
              const n = d[t];
              return /* @__PURE__ */ w(
                N,
                {
                  ...n,
                  wrapperStyle: e,
                  key: n.value,
                  onClick: () => {
                    h(n), a(n);
                  },
                  hasDivider: t < d.length - 1
                }
              );
            }
          }
        ) })
      ]
    }
  );
};
export {
  V as CascadingMenu
};
//# sourceMappingURL=index.es75.js.map
